const messages = {
  SIGNIN: {
    email: {
      formatEmail: 'E-mail need to use format example@company.com',
      required: 'Field required',
    },
    password: {
      required: 'Field required',
    },
  },
  SMS: {
    balance: {
      noBalance:
        'Your credit balance is 0. Please top-up your account to be able to use this service.',
    },
  },
};

export default messages;
